import { render, staticRenderFns } from "./FullDialogGrupo.vue?vue&type=template&id=555b372f&"
import script from "./FullDialogGrupo.vue?vue&type=script&lang=js&"
export * from "./FullDialogGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports